import { Component } from 'react';
import './index.scss';
import { BrowserRouter as Router, Routes, Link, Route } from 'react-router-dom';
// import siteLogo from "../../assets/images/logo.svg";
import { ReactComponent as IconHome } from '../../assets/images/icons/iconHome.svg';
import CountdownTimer from '../CustomCounter';
import * as API from '../../configuration/apiconfig';
import { jwtDecode } from 'jwt-decode';
const isConfirmationPage = window.location.pathname === '/confirmation';

class Header extends Component {
  redirectToHome = () => {
    API.logoutUser();
    window.location.href = `/?cinemaid=${localStorage.getItem('cinemaid')}`;
  };

  render() {
    var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
    let getLoginModule = JSON.parse(window.constant.SHOW_LOGGED_IN_USER_NAME);
    let checkGuestMessage = JSON.parse(window.constant.SHOW_WELCOME_GUEST);
    let firstName = API.getValueFromCookie('firstname');
    let lastName = API.getValueFromCookie('lastname');
    let fullName = firstName != null && lastName != null ? `${firstName} ${lastName}` : '';

    let getAccessToken = API.getValueFromCookie('accessToken');
    let checkIfUserLoggedIn = getAccessToken != null ? jwtDecode(getAccessToken).role : '';
    let isUserLoggedIn = checkIfUserLoggedIn.toLowerCase() === 'cinemacustomer' ? true : false;

    return (
      <>
        <header className="innerPageHeader">
          {this.props.logo && (
            <aside className="siteLogo">
              <a href="javascript:;">
                <img src={'/assets/images/logo.svg'} alt="Cinemas" className="img-fluid" width={window.constant.LOGO_WIDTH} height={window.constant.LOGO_HEIGHT} />
              </a>
            </aside>
          )}
          <div className="right-column">
            {getLoginModule && fullName != '' ? (
              <div className={`user-logged ${this.props.timer ? '' : 'add-user-border'}`}>
                <p className="welcome-text">Welcome Back</p>
                <p className="logged-username">
                  <img src={'/assets/images/user-icon.svg'} alt="User Icon" className="img-fluid" />
                  {`${fullName.length > 20 ? fullName.substring(0, 20) + '...' : fullName}`}
                </p>
              </div>
            ) : checkGuestMessage && window.location.pathname != '/movies' && window.location.pathname != '/showtime' ? (
              <div className={`user-logged ${this.props.timer ? '' : 'guest'} ${isConfirmationPage ? 'confirmation-page' : ''}`}>
                <p className="welcome-text">Hi,</p>
                <p className="logged-username">
                  <img src={'/assets/images/user-icon.svg'} alt="User Icon" className="img-fluid" />
                  Guest
                </p>
              </div>
            ) : null}
            {this.props.homeIcon && !isUserLoggedIn && (
              <aside className={`home-icon ${isConfirmationPage ? 'guest' : ''}`}>
                <Link to={`/?cinemaid=${getCinemaIdFromLocalstorage}`} className="homeButton" title="Go Home">
                  <IconHome className="img-fluid" />
                  <span>Go Home</span>
                </Link>
              </aside>
            )}
            {this.props.timer && <CountdownTimer hideGCModalBookingTimerElapse={this.props.hideGCModalBookingTimerElapse} isUserLoggedIn={isUserLoggedIn} />}
            {isUserLoggedIn && (
              <div className="user-logout">
                <button onClick={() => this.redirectToHome()}>
                  <img src={'/assets/images/logout-icon.svg'} alt="User Logout" className="img-fluid" />
                  LOGOUT
                </button>
              </div>
            )}
          </div>
        </header>
      </>
    );
  }
}

export default Header;
